import { Actions, Context } from 'vuex-smart-module';
import { Store } from 'vuex';

import AppStore from '@/store/appstore';
import PollsState from './state';
import PollsMutations from './mutations';
import PollsGetters from './getters';

export default class PollsActions extends Actions<
  PollsState,
  PollsGetters,
  PollsMutations,
  PollsActions
> {
  app!: Context<typeof AppStore>;

  $init(store: Store<typeof AppStore>): void {
    this.app = AppStore.context(store);
  }
}
